export const FILE_UPLOAD = {
  File_type: ".jpg,.jpeg,.png,",
  File_types:
    ".jpg,.jpeg,.png,.gif,.tiff,.psd,.pdf,.eps,.ai,.indd,.raw,.bmp,'.pptx',.pptm,.ppt,.xps,.potx,.potm,.pot,.thmx,.ppsx,.pps,.ppam,.ppa,.odp,.doc,.txt,.dot,.wbk,.docx,.docm,.dotx,.dotm,.docb,.odt,.xls,.xlt,.xlm,.xlsx,.xlsm,.xltx,.xltm,.xlsb,.xla,.xlam,.xll,xlw,.ods",
  Register_doc: "/file-uploader/uploadS3?entityName=Register-Book",
  Schedule_doc: "/file-uploader/uploadS3?entityName=schedule-Book",
  Profile_image: "/file-uploader/uploadS3?entityName=profileImage",
  Complaint_doc_image: "/file-uploader/uploadS3?entityName=Complain",
  Vikaskame_doc: "/file-uploader/uploadS3?entityName=vikas-kame",
  MLA_fund_expenses: "/file-uploader/uploadS3?entityName=mla-fund-expense",
  Office_image: "/file-uploader/uploadS3?entityName=officeImage",
  Baner: "/file-uploader/uploadS3?entityName=Banner",
  Email: "/file-uploader/uploadS3?entityName=Mail"
};
